import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Message from 'js/components/atoms/Label/Message';
import { AUTH_SIGNUP_ROUTE_PATH, AUTH_RESET_PASSWORD_ROUTE_PATH } from 'js/constants/routes';
import { localizedText } from 'js/localization';
import { Container } from './style';
var LOG_IN_TITLE = localizedText.LOG_IN_TITLE,
    LOG_IN_DESCRIPTION = localizedText.LOG_IN_DESCRIPTION,
    EMAIL_LABEL = localizedText.EMAIL_LABEL,
    PASSWORD_LABEL = localizedText.PASSWORD_LABEL,
    LOG_IN_SUBMIT_LABEL = localizedText.LOG_IN_SUBMIT_LABEL,
    LOG_IN_SUBMITTING_LABEL = localizedText.LOG_IN_SUBMITTING_LABEL,
    FORGOT_PASSWORD_LINK_TEXT = localizedText.FORGOT_PASSWORD_LINK_TEXT,
    NO_ACCOUNT_TEXT = localizedText.NO_ACCOUNT_TEXT,
    SIGN_UP_LINK_TEXT = localizedText.SIGN_UP_LINK_TEXT;
export default function LoginPage(_ref) {
  var _ref$messages = _ref.messages,
      messages = _ref$messages === void 0 ? {} : _ref$messages,
      onSubmit = _ref.onSubmit,
      isSubmitting = _ref.isSubmitting;
  return React.createElement(Container, null, React.createElement("strong", null, LOG_IN_TITLE), React.createElement("br", null), React.createElement("small", null, LOG_IN_DESCRIPTION), React.createElement(Message, {
    message: messages.success,
    type: 'success'
  }), React.createElement(Message, {
    message: messages.error,
    type: 'error'
  }), React.createElement("form", {
    method: "POST",
    action: "#",
    onSubmit: onSubmit
  }, React.createElement("label", {
    htmlFor: "email"
  }, EMAIL_LABEL, React.createElement("br", null), React.createElement("input", {
    className: "form-control",
    type: "email",
    name: "email"
  })), React.createElement("br", null), React.createElement("label", {
    htmlFor: "password"
  }, PASSWORD_LABEL, React.createElement("br", null), React.createElement("input", {
    className: "form-control",
    type: "password",
    name: "password"
  })), React.createElement("br", null), isSubmitting ? React.createElement("button", {
    disabled: true,
    type: "submit",
    className: "btn btn-primary"
  }, LOG_IN_SUBMITTING_LABEL) : React.createElement("button", {
    type: "submit",
    className: "btn btn-primary"
  }, LOG_IN_SUBMIT_LABEL), React.createElement("br", null), React.createElement(Link, {
    to: AUTH_RESET_PASSWORD_ROUTE_PATH
  }, FORGOT_PASSWORD_LINK_TEXT), React.createElement("br", null), React.createElement("span", null, NO_ACCOUNT_TEXT, " ", React.createElement(Link, {
    to: AUTH_SIGNUP_ROUTE_PATH
  }, SIGN_UP_LINK_TEXT))));
}
LoginPage.propTypes = {
  messages: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired
};